import React from 'react';
import SEOMeta from 'containers/SEOMeta';
import AlertMap from './containers/AlertMap';
import AlertRelated from './containers/AlertRelated';
import AlertContent from './containers/AlertContent';
import { selectors } from './ducks/article.duck';

const AlertsSingle = () => (
  <div className="l-alert">
    <SEOMeta selector={selectors.data} />
    <div className="l-alert__map">
      <AlertMap
        types={['xs']}
      />
    </div>
    <div className="l-alert__content">
      <AlertContent />
    </div>
    <div className="l-alert__related">
      <AlertRelated />
    </div>
  </div>
);

export default AlertsSingle;
